module.exports = __webpack_public_path__ + "img/ezc-wt-joker-animation.4df51f29.gif";